<template>
  <transition-group tag='div'>
    <div v-show='show' :key='0' class='preview_transparent' @click='close'>
      <div class='preview' @touchstart='movstart' @touchmove='mov' @touchend='movend'>
        <ul :style='[ulWidth, styleObj]' :left='left'>
          <li v-for='item in options' :style='liWidth'>
            <div>
              <img :src='item' :alt='item.alt'>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </transition-group>
</template>

<script>
  const sw = document.body.scrollWidth
  export default {
    name: 'c-preview',
    props: {
      show: {
        type: Boolean
      },
      options: {
        type: Array,
        require: true,
        default: []
      },
      dis: {
        type: Number,
        default: 0
      }
    },
    watch: {
      dis () {
        console.info('previewIndex=', this.dis)
        this.cur = this.dis || 0
      }
    },
    data () {
      return {
        start: 0,
        end: 0,
        cur: 0,
        sh: 0
      }
    },
    mounted () {
      this.cur = this.dis || 0
    },
    computed: {
      ulWidth () {
        console.info('document.body==', JSON.stringify(document.body.offsetHeight))
        return {
          width: `${sw * this.options.length}px`
        }
      },
      liWidth () {
        return `width: ${sw}px`
      },
      styleObj () {
        const postion = this.cur * sw
        let transform = `translate3d(-${postion}px,0,0)`
        return {
          transform: transform,
          'transition': '400ms'
        }
      },
      left () {
        const postion = this.cur * sw
        return `-${postion}px`
      }
    },
    methods: {
      movstart (e) {
        this.start = e.targetTouches[0].clientX
        this.end = e.targetTouches[0].clientX
      },
      mov (e) {
        this.end = e.targetTouches[0].clientX
      },
      movend (e) {
        const pos = this.start - this.end
        if (Math.abs(pos) > 20) {
          if (pos > 0 && this.cur < this.options.length - 1) { // 向右滑动
            this.cur = this.cur + 1
          }
          if (pos < 0 && this.cur > 0) { // 向左滑动
            this.cur = this.cur - 1
          }
        }
      },
      close () {
        this.$emit('on-close')
      },
      computeStyle () {
        this.cur = this.dis || 0
        const postion = this.cur * sw
        this.styleObj.transform = `translate3d(-${postion}px,0,0)`
        this.left = `-${postion}px`
      }
    }
  }

</script>

<style>
  .preview_transparent {
    position: fixed;
    z-index: 5001;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-flow: row nowrap;
    justify-content:space-between;
    align-items: center;
  }

  .preview>ul {
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    margin: 0px;
  }

  .preview>ul>li {
    height: 100%;
    float: left;
    text-align: center;
  }

  .preview>ul>li>div {
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 100%;
  }

  .preview img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
  }

  .previewbtn {
    position: absolute;
    width: 0px;
    z-index: 1;
    left: 50%;
    top: 38%;
  }
</style>
